import {DateTime} from "luxon";

const minTwoDigits = (number: number) => {
    return (number < 10 ? '0' : '') + number;
}

export default {
    install: (app: any) => {
        app.config.globalProperties.$luxon = DateTime;

        window.secondsToHumanReadable = app.config.globalProperties.$secondsToHumanReadable = (totalSeconds: number): string => {
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            let output = '';

            if (hours !== 0) {
                output += minTwoDigits(Math.floor(hours)) + ':';
            }

            return output
                + minTwoDigits(Math.floor(minutes))
                + ':' + minTwoDigits(Math.floor(seconds));
        }

        window.humanReadableToSeconds = (humanReadable: string): number => {
            if (!humanReadable.includes(':')) {
                const value = parseInt(humanReadable);

                if (isNaN(value)) {
                    return 0;
                }

                return value;
            }

            const parts = humanReadable.split(':');

            let hoursInSeconds, minutesInSeconds, seconds;
            if (parts.length === 3) {
                hoursInSeconds = parseInt(parts[0]) * 60 * 60;
                minutesInSeconds = parseInt(parts[1]) * 60;
                seconds = parseInt(parts[2]);
            } else {
                hoursInSeconds = 0;
                minutesInSeconds = parseInt(parts[0]) * 60;
                seconds = parseInt(parts[1]);
            }

            if (isNaN(hoursInSeconds) || isNaN(minutesInSeconds) || isNaN(seconds)) {
                return 0;
            }

            return hoursInSeconds + minutesInSeconds + seconds;
        }

        window.numberToReadable = app.config.globalProperties.$numberToReadable = (number: number, digits: number): string => {
                const lookup = [
                    { value: 1, symbol: "" },
                    { value: 1e3, symbol: "k" },
                    { value: 1e6, symbol: "M" },
                ];

                const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
                const item = lookup.slice().reverse().find(function(item) {
                    return number >= item.value;
                });

                return item ? (number / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
        }
    }
}
